/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core'

export function TableHeader (props) {
  return <thead {...props} />
}
